import { Injectable } from '@angular/core';
import { AppNotificationUtilClass, Plani8DataService } from '@monorepo/services';
import { from, of } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, finalize, take, withLatestFrom } from 'rxjs/operators';
import { TOrderChecklistActionType } from './order-checklist.models';
import * as OrderChecklistActions from './order-checklist.action';
import { Store } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import * as orderChecklistSelectors from './order-checklist.selector';

@Injectable({ providedIn: 'root' })
export class OrderChecklistEffects {
  constructor(
    private actions$: Actions,
    private plani8DataService: Plani8DataService,
    private appNotificationUtilClass: AppNotificationUtilClass,
    private store: Store<TPlani8State>,
  ) {}

  getOrderChecklist$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TOrderChecklistActionType.GetOrderChecklist),
      switchMap((action: OrderChecklistActions.GetOrderChecklist) =>
        from(this.appNotificationUtilClass.presentLoading()).pipe(
          take(1),
          switchMap((loaderEl) =>
            this.plani8DataService.getOrderChecklistListing(action.payload).pipe(
              map((res) => new OrderChecklistActions.GetOrderChecklistSuccess(res)),
              catchError(() => of(new OrderChecklistActions.GetOrderChecklistFailure())),
              finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
            ),
          ),
        ),
      ),
    ),
  );

  refreshOrderChecklist$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TOrderChecklistActionType.RefreshOrderChecklist),
      withLatestFrom(
        this.store.select(orderChecklistSelectors.getUserPaginationOption),
        this.store.select(orderChecklistSelectors.getOrderChecklistSelectedFilters),
      ),
      map(([action, paginationOption, filterModel]) => {
        const filters = filterModel?.selectedFilters || [];
        return new OrderChecklistActions.GetOrderChecklist({
          filters,
          page_number: paginationOption.pageNo,
          page_size: paginationOption.pageSize,
        });
      }),
    ),
  );
}
